<template>
  <v-card flat class="pa-4">
    <v-tooltip bottom  max-width="300" nudge-top="20" nudge-left="100" open-delay="1000">
      <template v-slot:activator="{on}">
        <v-switch v-model="lotTrackingForProducts"
                    :hint="lotTrackingForProducts?'All existing product lot information is removed if disabled':''" persistent-hint
                    @change="toggleLot('lotTrackingForProducts')">
          <span slot="label" v-on="on">Track lots for in-bond products</span>
        </v-switch>
      </template>
      When enabled (by default, and recommended), in-bond product inventory is kept by lot code.
      All operations on in-bond products will require a lot code to be specified and
      you will be able to trace product activity by lot code.
      Turning this option off, automatically turns off lot tracking for duty-paid products, too.
    </v-tooltip>

    <v-tooltip bottom  max-width="300" nudge-top="20" nudge-left="100" open-delay="1000">
      <template v-slot:activator="{on}">
        <v-switch v-model="lotTrackingForDutyPaid" :disabled="!settings.lotTrackingForProducts" @change="toggleLot('lotTrackingForDutyPaid')"
                    :hint="lotTrackingForDutyPaid?'All existing duty-paid product lot information is removed if disabled':''" persistent-hint>
          <span slot="label" v-on="on">Track lots for duty-paid products</span>
        </v-switch>
      </template>
      If enabled, duty-paid product will be kept in inventory by lot code,
      and all operations on duty-paid products (such as shipments) will require lot to be specified.
      When disabled, lot codes don't need to be specified.
    </v-tooltip>

    <v-row dense class="mt-4">
      <v-col cols="3">Batch move numbers</v-col>
      <v-col cols="3">
        <v-text-field label="Prefix" v-model="preferences.numberPrefix" :rules="[fieldRules.maxLength(10)]" outlined dense :counter="10"/>
      </v-col>
      <v-col cols="3">
        <v-text-field label="Suffix" v-model="preferences.numberSuffix" :rules="[fieldRules.maxLength(10)]" outlined dense :counter="10"/>
      </v-col>
      <v-col cols="3">
        <decimal-number-input label="Start at" v-model="preferences.numberStart" :precision="0" integer prefix=""/>
      </v-col>
    </v-row>


    <v-dialog v-model="showConfirm" persistent max-width="400">
      <v-card>
        <v-card-title>Are you sure?</v-card-title>
        <v-divider/>
        <v-card-text class="pt-4 text-body-1 error--text">
          Lot information for all {{productType==='lotTrackingForDutyPaid'?'duty-paid':''}} products will be lost if you continue!
        </v-card-text>
        <v-divider/>
        <v-card-actions class="pr-6">
          <v-spacer></v-spacer>
          <v-btn color="error" plain @click="toggleLotDisable()">Disable lot tracking</v-btn>
          <v-btn color="primary" @click="toggleLotCancel()">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import settingsPreferences from '@/views/settings/preferences/settingsPreferences'

export default {
  name: 'SettingsPreferencesInventoryProducts',
  mixins: [settingsPreferences],
  data() {
    return {
      lotTrackingForProducts: false,
      lotTrackingForDutyPaid: false,
      showConfirm: false,
      productType: '',
      preferences: {}
    }
  },
  watch: {
    preferences: {
      async handler() {
        const results = await this.$apiCall(`mutation SettingsPreferencesInventoryProducts($input:ProductBatchMovePreferencesInput!) {
                                              productsBatchMoveSetPreferences(input:$input) {
                                                numberPrefix, numberSuffix, numberStart
                                              }
                                            }`,
                                            {input:this.preferences});
      },
      immediate: false,
      deep: true
    }
  },
  async created() {
    const results = await this.$apiCall(`query SettingsPreferencesInventoryProducts {
                                          productsBatchMovePreferences {
                                            numberPrefix, numberSuffix, numberStart
                                          }
                                        }`,
                                        {});
    if (!results.error)
      this.preferences = results.data.productsBatchMovePreferences;

    this.lotTrackingForProducts = this.settings.lotTrackingForProducts;
    this.lotTrackingForDutyPaid = this.settings.lotTrackingForDutyPaid;
  },
  methods: {
    toggleLot(productType) {
      if (productType === 'lotTrackingForDutyPaid' && !this.lotTrackingForDutyPaid ||
          productType === 'lotTrackingForProducts' && !this.lotTrackingForProducts) {
        this.productType = productType;
        this.showConfirm = true;
      }
      else
        this.settings[productType] = true;
    },
    toggleLotDisable() {
      if (this.productType === 'lotTrackingForProducts') {
        this.settings.lotTrackingForProducts = false;
        this.settings.lotTrackingForDutyPaid = this.settings.lotTrackingForDutyPaid && this.settings.lotTrackingForProducts;
      }
      else if (this.productType === 'lotTrackingForDutyPaid')
        this.settings.lotTrackingForDutyPaid = false;
      this.showConfirm = false;
    },
    toggleLotCancel() {
      if (this.productType === 'lotTrackingForProducts') {
        this.lotTrackingForProducts = true;
        this.settings.lotTrackingForDutyPaid = this.settings.lotTrackingForDutyPaid && this.settings.lotTrackingForProducts;
      }
      else if (this.productType === 'lotTrackingForDutyPaid')
        this.lotTrackingForDutyPaid = true;
      this.showConfirm = false;
    }
  }
}
</script>